import { Component, inject, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../components/layout/sidebar/sidebar.component';
import { ButtonComponent } from '../../components/feedback/button/button.component';
import { ConfigurationStore } from '../../services/api/configuration/configuration-store.service';
import { ESiteContext, IConfiguration } from '@web/dtos';
import { SnackbarComponent } from '../../components/data-display/snackbar/snackbar.component';
import { AuthProvider } from '../../services/auth/auth.provider';
import { AuthProviderFactory } from '../../services/auth/auth-provider.factory';
import { SiteContextService } from '../../services/site-context/site-context.service';
import { ERoute } from '../../constants/routes.enum';
import { ThemeComponent } from '../../theming';

@Component({
  selector: 'aw-cms',
  imports: [
    CommonModule,
    FormsModule,
    RouterOutlet,
    SidebarComponent,
    ButtonComponent,
    SnackbarComponent,
    ThemeComponent
  ],
  templateUrl: './cms-page.component.html',
  styles: ``,
})
export class CmsPageComponent implements OnInit {
  private readonly auth: AuthProvider =
    inject(AuthProviderFactory).getProvider('cms');

  private readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);
  private readonly siteContextService: SiteContextService =
    inject(SiteContextService);
  private readonly router: Router = inject(Router);

  public readonly configuration: Signal<IConfiguration[]> =
    this.configurationStore.configuration;

  constructor() {
    this.siteContextService.setContext(ESiteContext.Cms);
  }

  protected isFooterPage(): boolean {
    return this.router.url.split(/[?#]/, 1)[0] === `/${ERoute.cms}/${ERoute.footer}`;
  }

  ngOnInit(): void {
    this.resetDomChanges();
  }

  resetDomChanges(): void {
    // Reset fonts
    const styles = Array.from(document.head.querySelectorAll('style'));
    styles.forEach(style => {
      if (
        style.innerHTML.includes('@font-face') ||
        style.innerHTML.includes('font-family')
      ) {
        style.remove();
      }
    });

    // Reset favicon
    const favicons = document.head.querySelectorAll('link[rel="icon"]');
    favicons.forEach(favicon => favicon.remove());

    // Reset title
    const title = document.head.querySelector('title');
    if (title) {
      title.innerHTML = 'Default Title';
    }
  }

  async logout(): Promise<void> {
    this.auth.logout();
  }

  public redirectToLicensePage(): void {
    this.router.navigate([`/${ERoute.cms}/${ERoute.license}`]);
  }
}
